import { useNetworkStatus } from '../../hooks/useNetworkStatus'
import { WifiOff, Wifi, RefreshCw } from 'lucide-react'
import { usePWA } from '../../hooks/usePWA'

interface Props {
  pendingCount?: number
}

export default function OfflineBanner({ pendingCount = 0 }: Props) {
  const { isOnline, wasOffline } = useNetworkStatus()
  const { updateAvailable, reloadForUpdate } = usePWA()

  // Actualización disponible
  if (updateAvailable) {
    return (
      <div className="w-full bg-aqua-600 text-white px-4 py-2 flex items-center justify-between text-sm font-semibold">
        <div className="flex items-center gap-2">
          <RefreshCw size={15} className="animate-spin" />
          <span>Nueva versión disponible</span>
        </div>
        <button
          onClick={reloadForUpdate}
          className="bg-white text-aqua-700 px-3 py-1 rounded-lg text-xs font-bold hover:bg-aqua-50 transition-colors"
        >
          Actualizar
        </button>
      </div>
    )
  }

  // Volvió a conectarse
  if (isOnline && wasOffline) {
    return (
      <div className="w-full bg-emerald-500 text-white px-4 py-2 flex items-center gap-2 text-sm font-semibold animate-fade-in">
        <Wifi size={15} />
        <span>
          ¡Conexión restaurada!
          {pendingCount > 0 && ` Sincronizando ${pendingCount} venta${pendingCount !== 1 ? 's' : ''} pendiente${pendingCount !== 1 ? 's' : ''}…`}
        </span>
      </div>
    )
  }

  // Sin conexión
  if (!isOnline) {
    return (
      <div className="w-full bg-orange-500 text-white px-4 py-2 flex items-center justify-between text-sm font-semibold">
        <div className="flex items-center gap-2">
          <WifiOff size={15} />
          <span>Sin conexión — modo offline activo</span>
        </div>
        {pendingCount > 0 && (
          <span className="bg-white/20 px-2 py-0.5 rounded-full text-xs">
            {pendingCount} en cola
          </span>
        )}
      </div>
    )
  }

  return null
}
